import { render, staticRenderFns } from "./PromotionTypeField.vue?vue&type=template&id=448e186b"
import script from "./PromotionTypeField.vue?vue&type=script&lang=js"
export * from "./PromotionTypeField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports